export const PageConstraints = {
  A4_HEIGHT: 1123,
  A4_WIDTH: 794,
  HEADER_RESERVED: 90,
  FOOTER_RESERVED: 40,
  SAFE_BODY_HEIGHT: 980,
  MAX_ITERATIONS: 3
};
